// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B7KE","title":"styles_title__1Zxol"};